import * as React from 'react'
import styled from 'styled-components'
import Container from '../frontend-lib/components/common/Container'
import Section from '../frontend-lib/components/common/Section'

const PrivacyPolicy = () => {
  return (
    <>
      <Section>
        <Container>
          <Title>個人情報保護方針</Title>
          <p>インベード株式会社は、事業運営上多くの個⼈情報を取扱うこととなるため、当社倫理綱領に基づいて本⽅針を定め、個⼈情報管理体制を確⽴し、企業として責任ある対応を実現するものとします。</p>
          <List>
            <ListItem>⽅針1. 個⼈情報の利⽤の⽬的をできる限り特定し、当該⽬的の達成に必要な範囲内で適切に取扱います。また、⽬的外利⽤を⾏なわないための措置を講じます。</ListItem>
            <ListItem>⽅針2. 個⼈情報は、適法かつ適正な⽅法で取得します。</ListItem>
            <ListItem>⽅針3. 個⼈情報は、本⼈の同意なく第三者に提供しません。</ListItem>
            <ListItem>⽅針4. 個⼈情報の管理にあたっては、漏洩・滅失・毀損の防⽌及び是正、その他の安全管理のために必要かつ適切な措置を講じるよう努めます。</ListItem>
            <ListItem>⽅針5. 個⼈情報の取扱いにあたっては、その情報を提供した本⼈が適切に関与し得るよう努め、可能な限り正確かつ最新の内容に保つよう努⼒します。</ListItem>
            <ListItem>⽅針6. 個⼈情報保護に関する法令を遵守し、また個⼈情報保護に関する社内規程を定め、継続的な⾒直しを⾏い遵守します。</ListItem>
            <ListItem>⽅針7. 個⼈情報保護に関する苦情及び相談に対応する窓⼝を設けて、適切に対応するよう努めます。</ListItem>
          </List>
          <MarginText>インベード株式会社</MarginText>
          <MarginText>代表責任者</MarginText>
          <MarginText>蕪木　恭兵</MarginText>
          <MarginText>（附則）</MarginText>
          <MarginText>2020年2⽉1⽇</MarginText>
          <MarginText>制定・施⾏</MarginText>
        </Container>
        <Container>
          <Title>個⼈情報</Title>
          <p>個⼈情報とは、ユーザー個⼈に関する情報であって、当該情報を構成する⽒名、住所、電話番号、メールアドレス、会社名、学校名その他の記述等により当該ユーザーを識別できるものをいいます。
            また、その情報のみでは識別できない場合でも、他の情報と容易に照合することができ、結果的にユーザー個⼈を識別できるものも個⼈情報に含まれます。</p>
        </Container>
        <Container>
          <Title>個⼈情報の利⽤⽬的</Title>
          <p>個⼈情報の利⽤⽬的は以下の通りです。利⽤⽬的を超えて利⽤することはありません。</p>
          <List>
            <ListItem>A. ユーザーの個⼈認証及びユーザー向け本サービスの提供</ListItem>
            <ListItem>B. 本サービスの利⽤に伴う連絡・メールマガジン・DM・各種お知らせ等の配信・送付</ListItem>
            <ListItem>C. ユーザーの承諾・申込みに基づく、本サービス利⽤企業等への個⼈情報の提供</ListItem>
            <ListItem>D. 属性情報･端末情報・位置情報・⾏動履歴等に基づく広告・コンテンツ等の配信・表⽰、本サービスの提供</ListItem>
            <ListItem>E. 本サービスの改善・新規サービスの開発・ポイント利⽤状況の調査・分析およびマーケティング</ListItem>
            <ListItem>F. キャンペーン・アンケート・モニター・取材等の実施</ListItem>
            <ListItem>G. 空メール送信者に対するURL情報の配信</ListItem>
            <ListItem>H. 本サービスに関するご意⾒、お問い合わせ、クチコミ投稿内容の確認・回答</ListItem>
            <ListItem>I. 利⽤規約等で禁じている、商⽤・転⽤⽬的での各種申込⾏為、各種多重申込、権利譲渡、虚偽情報登録などの調査と、それに基づく当該申込内容の詳細確認</ListItem>
          </List>
        </Container>
        <Container>
          <Title>ユーザーからお預かりした宛先情報について</Title>
          <p>本サービスでは、ユーザーから依頼されたメッセージ・商品等をお届けするために、ユーザー本⼈以外の宛先情報をお預かりすることがあります。
            本サービスは宛先情報をユーザーの依頼に基づいてメッセージ・商品等をお届けするためのみに利⽤し、個⼈情報として適切に管理します。宛先情報の登録・変更・削除はユーザーに委ねられており、本サービス側での変更や削除は原則として⾏いません。
            変更・削除を希望される⽅は、メッセージ・商品等の届け元であるユーザーへ直接お問い合わせください。なお､届け元にお⼼当たりがない場合は下記の個⼈情報管理の問い合わせ先にご連絡ください。</p>
        </Container>
        <Container>
          <Title>個⼈情報提供の任意性</Title>
          <p>本サービスにおいてそれぞれ必要となる項⽬を⼊⼒いただかない場合は、本サービスを受けられない場合があります。</p>
        </Container>
        <Container>
          <Title>個⼈情報の第三者への提供</Title>
          <p>当社は、原則として、ユーザー本⼈の同意を得ずに個⼈情報を第三者に提供しません。提供先・提供情報内容を特定したうえで、ユーザーの同意を得た場合に限り提供します。</p>
          <List>
            <ListItem>1. 提供先および⽬的について<br/>資料請求・応募・予約・購⼊等のサービス提供のため、本サービス利⽤企業等への提供</ListItem>
            <ListItem>2. 提供する個⼈情報の項⽬<br/>ユーザーから取得した情報（サービス利⽤履歴ほか、閲覧・検索・ブックマーク等あらゆる⾏動履歴に該当する情報を含む）のうち、利⽤⽬的の達成に必要な範囲の情報項⽬とします。</ListItem>
            <ListItem>3. 提供の⼿段⼜は⽅法<br/>書⾯もしくは電磁的な⽅法による送付または送信。</ListItem>
          </List>
          <p>ただし、以下の場合は、関係法令に反しない範囲で、ユーザーの同意なく個⼈情報を提供することがあります。</p>
          <List>
            <ListItem>A. ユーザーが第三者に不利益を及ぼすと判断した場合</ListItem>
            <ListItem>B. 公衆衛⽣の向上または児童の健全な育成の推進のために特に必要がある場合であって、ユーザー本⼈の承諾を得ることが困難である場合</ListItem>
            <ListItem>C. 国の機関若しくは地⽅公共団体またはその委託を受けた者が法令の定める事務を遂⾏することに対して協⼒する必要がある場合で、ユーザー本⼈の同意を得ることによりその事務の遂⾏に⽀障を及ぼすおそれがある場合</ListItem>
            <ListItem>D. 裁判所、検察庁、警察またはこれらに準じた権限を有する機関から、個⼈情報についての開⽰を求められた場合</ListItem>
            <ListItem>E. ユーザー本⼈から明⽰的に第三者への開⽰または提供を求められた場合</ListItem>
            <ListItem>F. 法令により開⽰または提供が許容されている場合</ListItem>
            <ListItem>G. 合併その他の事由による事業の承継に伴い個⼈情報を提供する場合であって、承継前の利⽤⽬的の範囲で取り扱われる場合</ListItem>
          </List>
        </Container>
        <Container>
          <Title>第三者提供に関する免責事項</Title>
          <p>以下の場合は、第三者による個⼈情報の取得に関し、当社は何らの責任を負いません。</p>
          <List>
            <ListItem>A. ユーザー⾃らが本サービスの機能または別の⼿段を⽤いて利⽤企業等に個⼈情報を明らかにする場合（なお、利⽤企業等における個⼈情報の取扱いについては、各利⽤企業に直接お問合せください）</ListItem>
            <ListItem>B. 本サービスに⼊⼒した情報により、期せずして本⼈が特定できてしまった場合</ListItem>
            <ListItem>C. 本サービスからリンクされる外部サイトにおいて、ユーザーより個⼈情報が提供され、またそれが利⽤された場合</ListItem>
            <ListItem>D. ユーザー本⼈以外がユーザー個⼈を識別できる情報（ID・パスワード等）を⼊⼿した場合</ListItem>
          </List>
        </Container>
        <Container>
          <Title>個⼈情報処理の外部委託</Title>
          <p>当社は、個⼈情報取扱い業務の⼀部または全部を外部委託することがあります。なお、委託先における個⼈情報の取扱いについては当社が責任を負います。</p>
        </Container>
        <Container>
          <Title>統計処理されたデータの利⽤</Title>
          <p>当社は、提供を受けた個⼈情報をもとに、個⼈を特定できないよう加⼯した統計データを作成することがあります。個⼈を特定できない統計データについては、当社は何ら制限なく利⽤することができるものとします。</p>
        </Container>
        <Container>
          <Title>個⼈情報の変更等</Title>
          <p>原則としてユーザー本⼈に限り、「個⼈情報の利⽤⽬的」の通知、登録した個⼈情報の開⽰、訂正、追加または削除、利⽤停⽌、ならびに第三者への提供の停⽌（以下「個⼈情報の変更等」といいます）を求めることができるものとします。
            具体的な⽅法については下記の個⼈情報管理の問い合わせ先にご連絡ください｡ただし、以下の場合は個⼈情報の変更等に応じないことがあります。</p>
          <List>
            <ListItem>A. ユーザー本⼈または第三者の⽣命、⾝体、財産その他の権利・利益を害するおそれがある場合</ListItem>
            <ListItem>B. 本サービスの適正な実施に著しい⽀障を及ぼすおそれがある場合</ListItem>
            <ListItem>C. 他の法令に違反することとなる場合</ListItem>
          </List>
          <p>また、当該個⼈情報の変更等に多額の費⽤を要する場合､その他の、個⼈情報の変更等を⾏うことが困難な場合であって、ユーザーの権利・利益を保護するため必要なこれに代わるべき措置をとるときは、個⼈情報の変更等に応じないことがあります。</p>
        </Container>
        <Container>
          <Title>個⼈情報の正確性</Title>
          <p>当社は、ご提供いただいた個⼈情報を正確にデータ処理するように努めます。ただし、ご提供いただいた個⼈情報の内容が正確かつ最新であることについては、ユーザーが責任を負うものとします。</p>
        </Container>
        <Container>
          <Title>機微な個⼈情報の取得制限</Title>
          <p>当社は、次に⽰す内容を含む個⼈情報の取得は原則として⾏いません。ただし、ユーザーが⾃ら提供した場合は、この限りではありません。</p>
          <List>
            <ListItem>A. 思想、信条及び宗教に関する事項</ListItem>
            <ListItem>B. ⼈種、⺠族、⾨地、本籍地（所在都道府県に関する情報を除く）、⾝体・精神障害、犯罪歴、その他社会的差別の原因となる事項</ListItem>
            <ListItem>C. 勤労者の団結権、団体交渉及びその他団体⾏動の⾏為に関する事項</ListItem>
            <ListItem>D. 集団⽰威⾏為への参加、請願権の⾏使、及びその他政治的権利の⾏使に関する事項</ListItem>
            <ListItem>E. 保健医療及び性⽣活</ListItem>
          </List>
          <p>また、当該個⼈情報の変更等に多額の費⽤を要する場合､その他の、個⼈情報の変更等を⾏うことが困難な場合であって、ユーザーの権利・利益を保護するため必要なこれに代わるべき措置をとるときは、個⼈情報の変更等に応じないことがあります。</p>
        </Container>
        <Container>
          <Title>本⼈確認について</Title>
          <p>当社は、各Webサービスへの会員登録や会員が本サービスを利⽤する場合、個⼈情報の開⽰、訂正、削除もしくは利⽤停⽌の求めに応じる場合など、個⼈を識別できる情報（⽒名､住所､電話番号､⽣年⽉⽇､メールアドレス､会員番号､パスワードなど）により、本⼈であることを確認します。
            ただし、本⼈以外が個⼈を識別できる情報を⼊⼿し使⽤した場合、当社は責任を負いません。</p>
        </Container>
        <Container>
          <Title>属性情報・端末情報・位置情報・⾏動履歴等の取得及び利⽤について</Title>
          <List>
            <ListItem>
              属性情報・端末情報・位置情報・⾏動履歴等（以下「⾏動履歴等」といいます）のうちCookie等について<br/>
              当社は、ユーザーのプライバシーの保護、利便性の向上、広告の配信および統計データの取得のため、Cookieを使⽤します。
              また、CookieやJavaScript等の技術を利⽤して、ご提供いただいた情報のうち、年齢や性別、職業、居住地域など個⼈が特定できない属性情報（組み合わせることによっても個⼈が特定できないものに限られます）や端末情報、
              本サービスサイト内におけるユーザーの⾏動履歴（アクセスしたURL、コンテンツ、参照順等）およびスマートフォン等利⽤時の、ユーザーの承諾・申込みに基づく位置情報を取得することがあります。
              ただし、Cookie及び⾏動履歴等には個⼈情報は⼀切含まれません。また、本サービスでは、ユーザーに適切な広告を配信するために⾏動ターゲティング広告サービスを利⽤しています。
              （携帯電話からアクセスしている場合はオプトアウト機能が利⽤できないことがあります）
            </ListItem>
            <ListItem>
              ⾏動履歴等のうち以下の場合のアクセスログ等について<br/>
              当社はユーザーがログインして本サービスを利⽤した場合には、個⼈を特定したうえで、当該ログイン以前からの⾏動履歴等を⽤いて、
              広告・コンテンツ等の配信・表⽰および本サービスの提供をする場合があります。こちらの広告等の配信停⽌については、下記の個⼈情報管理の問い合わせ先にご連絡ください｡
            </ListItem>
          </List>
          <p>また、当該個⼈情報の変更等に多額の費⽤を要する場合､その他の、個⼈情報の変更等を⾏うことが困難な場合であって、ユーザーの権利・利益を保護するため必要なこれに代わるべき措置をとるときは、個⼈情報の変更等に応じないことがあります。</p>
        </Container>
        <Container>
          <Title>個⼈情報管理責任者</Title>
          <MarginText>インベード株式会社</MarginText>
          <MarginText>当該サービス 担当執⾏役員</MarginText>
          <MarginText>個⼈情報に関するお問い合わせは<a href="mailto:beauty-info@kamisma.com">こちら</a></MarginText>
          <MarginText>※お電話の場合は、正確を期すため、録⾳している場合があります。あらかじめご了承ください。</MarginText>
        </Container>
        <Container>
          <Title>プライバシーポリシーの変更</Title>
          <p>当社は、法令等の定めがある場合を除き、プライバシーポリシーを随時変更することができるものとします。</p>
        </Container>
      </Section>
    </>
  )
}

export default PrivacyPolicy

const Title = styled.h2`
  margin: 0;
  font-size: 36px;
  font-weight: bold;
  line-height: 54px;
`

const List = styled.ul`
  margin: 24px;
`

const ListItem = styled.li`
  margin: 12px;
`

const MarginText = styled.div`
  margin: 10px 0px;
`
